module.exports = require('lodash').last